import { useEffect } from 'react'

export function useServiceWorker() {
  useEffect(() => {
    if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
      window.addEventListener('load', () => {
        navigator.serviceWorker
          .register('/sw.js')
          .then((registration) => {
            console.log('🔧 SW registered successfully');
            
            // Listen for controlling service worker changes
            navigator.serviceWorker.addEventListener('controllerchange', () => {
              console.log('🔄 SW: Controller changed - new version active');
              // Optionally reload to get fresh content
              // window.location.reload();
            });

            // Check for updates more frequently during development/testing
            setInterval(() => {
              registration.update();
            }, 5 * 60 * 1000); // Every 5 minutes for faster update detection

            // Handle updates with better UX
            registration.addEventListener('updatefound', () => {
              const newWorker = registration.installing;
              console.log('🆕 SW: Update found, installing new version...');
              
              if (newWorker) {
                newWorker.addEventListener('statechange', () => {
                  if (newWorker.state === 'installed') {
                    if (navigator.serviceWorker.controller) {
                      // New content available - auto-refresh for better UX
                      console.log('✨ SW: New version installed, refreshing page...');
                      setTimeout(() => {
                        window.location.reload();
                      }, 1000); // Small delay to ensure smooth transition
                    } else {
                      // First install
                      console.log('🎉 SW: App is ready for offline use');
                    }
                  }
                });
              }
            });
          })
          .catch((registrationError) => {
            console.error('❌ SW registration failed:', registrationError);
          });
      })
    }
  }, [])

  // Enable background sync with better error handling
  useEffect(() => {
    if ('serviceWorker' in navigator && 'SyncManager' in window) {
      navigator.serviceWorker.ready.then((registration) => {
        // Register background sync
        return (registration as any).sync?.register('sync-messages');
      }).catch((err) => {
        console.warn('⚠️ Background sync registration failed:', err);
      });
    }
  }, []);
  
  // Force cache refresh on mount in production
  useEffect(() => {
    if (process.env.NODE_ENV === 'production' && 'caches' in window) {
      // Clear any stale franchise-gpt caches on app start
      caches.keys().then(cacheNames => {
        const oldCaches = cacheNames.filter(name => 
          name.startsWith('franchise-gpt-') && 
          !name.includes('2025-07-13-v2.1')
        );
        
        if (oldCaches.length > 0) {
          console.log('🧹 Cleaning up old caches:', oldCaches);
          return Promise.all(oldCaches.map(name => caches.delete(name)));
        }
      }).catch(err => {
        console.warn('Cache cleanup failed:', err);
      });
    }
  }, [])
}